<div fxLayout="row wrap">
  <ng-container #menuContainer />
</div>
